module.exports = __webpack_public_path__ + "img/TRAVEL-TC.bf9096d7.jpg";